import script from "./UserIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserIcon.vue?vue&type=script&lang=ts&setup=true"

import "./UserIcon.vue?vue&type=style&index=0&id=39beed7c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39beed7c"]])

export default __exports__